let _didIntercomBoot = false;

export const didIntercomBoot = () => {
    return _didIntercomBoot;
};

export const setDidIntercomBoot = (value: boolean): void => {
    _didIntercomBoot = value;
};
